<form [formGroup]="form" class="ht-form" (ngSubmit)="onSubmit()">
  <div class="ht-form-item">
    <div class="ht-form-item-title">
      {{ 'auth.signup.form.email' | translate }}
    </div>
    <div class="ht-form-item-control">
      <ht-input
        [label]="'auth.signup.form.email' | translate"
        type="email"
        formControlName="email"
        [fullWidth]="true"
      ></ht-input>
    </div>
  </div>

  <div class="ht-form-item">
    <div class="ht-form-item-title">
      {{ 'auth.signup.form.password' | translate }}
    </div>
    <div class="ht-form-item-control">
      <ht-input
        [label]="'auth.signup.form.password' | translate"
        type="password"
        formControlName="password"
        [fullWidth]="true"
        [helpText]="'auth.signup.form.passwordHelpText' | translate"
      ></ht-input>
    </div>
  </div>

  <div class="ht-form-item">
    <div class="ht-form-item-title">
      {{ 'auth.signup.form.repeatPassword' | translate }}
    </div>
    <div class="ht-form-item-control">
      <ht-input
        [label]="'auth.signup.form.repeatPassword' | translate"
        type="password"
        formControlName="checkPassword"
        [fullWidth]="true"
      ></ht-input>
    </div>
  </div>

  <div class="ht-form-item">
    <div class="ht-form-item-title">
      {{ 'auth.signup.form.organization' | translate }}
    </div>
    <div class="ht-form-item-control">
      <ht-input
        [label]="'auth.signup.form.organization' | translate"
        type="text"
        formControlName="organization"
        [fullWidth]="true"
        [helpText]="'auth.signup.form.organizationHelpText' | translate"
      ></ht-input>
    </div>
  </div>

  <div class="ht-form-item">
    <div class="ht-form-item-control">
      <ht-checkbox
        [label]="'auth.signup.form.agreeLabel' | translate"
        formControlName="agree"
      >
        {{ 'auth.signup.form.agreePrefix' | translate }}
        <a
          href="https://uploads-ssl.webflow.com/5fbd0d2e5cfe50b164243272/60195d14568b9bb23bad6f9a_Hubtype_Platform_Terms_of_Use.pdf"
          target="_blank"
        >
          {{ 'auth.signup.form.termsOfService' | translate }}
        </a>
        {{ 'auth.signup.form.and' | translate }}
        <a
          href="https://uploads-ssl.webflow.com/5fbd0d2e5cfe50b164243272/615ead909a291d10c240e33c_20180524_Hubtype_Privacy_Policy%20(1).pdf"
          target="_blank"
        >
          {{ 'auth.signup.form.privacyPolicy' | translate }}
        </a>
      </ht-checkbox>
    </div>
    <div class="ht-form-item-control">
      <ht-checkbox
        [label]="'auth.signup.form.updatesLabel' | translate"
        formControlName="updates"
      >
        {{ 'auth.signup.form.updatesContent' | translate }}
      </ht-checkbox>
    </div>
  </div>

  @if (form.errors?.serverError) {
    <div class="ht-form-row">
      <div class="error-alert">
        <i class="fa-solid fa-circle-xmark"></i>
        <span>{{ form.errors?.serverError }}</span>
      </div>
    </div>
  }

  <div class="ht-form-actions">
    <button
      ht-button-primary
      type="submit"
      size="large"
      [fullWidth]="true"
      #submitButton
    >
      {{ 'auth.signup.form.signUp' | translate }}
    </button>
  </div>
</form>
